import React from "react";
import {
  setPreviousReport,
  toggleModal,
} from "app/store/transmission/slice/transmissionSlice";

import formatDate from "utils/formatDate";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "components/LoadingSpinner";

import {
  WarningOutlined as WarningIcon,
  Error as ErrorIcon,
  Receipt as ReceiptIcon,
  Apartment as ApartmentIcon,
} from "@mui/icons-material";
import { useGetPreviousReportsQuery } from "app/store/transmission/api/transmissionDetailApi";
import PdfModal from "../pdf/modals/PdfModal/PdfModal";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const PreviousReport = () => {
  const dispatch = useDispatch();

  const { isPreviousReportModal, reportId, isPdfModal } = useSelector(
    (state) => state.transmission
  );

  const {
    isLoading,
    isFetching,
    data: previousReports,
  } = useGetPreviousReportsQuery({
    reportId,
    isReport: isPreviousReportModal,
  });

  return (
    <>
      {isPreviousReportModal && (
        <ModalWrapper
          title="Previous Reports"
          show={isPreviousReportModal}
          onClose={() => {
            dispatch(toggleModal({ type: "previousReport", value: false }));
          }}
          maxWidth="xs"
        >
          {!isLoading && previousReports && !previousReports.length ? (
            <div className="view-pdf__previous-reports--content">
              No previous reports available
            </div>
          ) : isLoading || isFetching ? (
            <div className="view-pdf__previous-reports--content">
              <LoadingSpinner color="secondary" />
            </div>
          ) : (
            previousReports &&
            previousReports.map((item, index) => {
              return (
                item?.report_date && (
                  <div
                    key={`previous-report-${index}`}
                    className="view-pdf__previous-reports-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(toggleModal({ type: "pdfModal", value: true }));
                      dispatch(
                        setPreviousReport({
                          id: item?._id,
                          date: item?.report_date,
                          isLegacy: item?.legacy ?? true,
                          billingCode: item?.billing_code,
                        })
                      );
                    }}
                  >
                    {formatDate(item.report_date, "MM/DD/YYYY") || "--"}
                    {item?.billable && <ReceiptIcon color="#94ba33" />}
                    {item?.note?.evoke_notes?.some(({ content }) =>
                      content?.some(({ alert }) => alert === "Critical")
                    ) && <ErrorIcon style={{ color: "red" }} />}
                    {item?.note?.evoke_notes?.some(({ content }) =>
                      content?.some(({ alert }) => alert === "Warning")
                    ) && <WarningIcon style={{ color: "orange" }} />}
                    {item?.transmission_type === "inOffice" && (
                      <ApartmentIcon color="info" fontSize="small" />
                    )}
                  </div>
                )
              );
            })
          )}
        </ModalWrapper>
      )}

      {isPdfModal && <PdfModal />}
    </>
  );
};

export default PreviousReport;
